<template>
  <div 
    :class="['segmented-buttons', {'segmented-buttons--large': largeButtons}]" 
    class="officials-page-toggle ">
    <router-link
      v-for="{ routeName, text, isCurrent } of toggleData"
      :key="routeName"
      :to="{ name: routeName }"
      :aria-current="isCurrent ? 'page' : false"
      :class="buttonClass(isCurrent)"
    >
      {{ text }}
    </router-link>
  </div>
</template>

<script>
import routeNames from "Constants/campaign/civicactioncenter/routeNames";

export default {
  name: "OfficialsPageToggle",
  props: {
    largeButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    toggleData() {
      const { CANDIDATES, ELECTED_OFFICIALS } = routeNames;
      return [
        {
          routeName: CANDIDATES,
          text: this.$t("cac.app.candidates"),
          isCurrent: this.$route.name === CANDIDATES
        },
        {
          routeName: ELECTED_OFFICIALS,
          text: this.$t("cac.app.elected_officials"),
          isCurrent: this.$route.name === ELECTED_OFFICIALS
        }
      ];
    }
  },
  methods: {
    buttonClass(isCurrent) {
      return ["btn", isCurrent ? "btn--primary" : "btn--primary-inverse"];
    }
  }
};
</script>
